﻿import "./setup.js";
import "bootstrap/js/src/alert.js";
import "bootstrap/js/src/collapse.js";
import "bootstrap/js/src/tab.js";
import "bootstrap/js/src/modal.js";
import "bootstrap/js/src/carousel.js";
import "./nav.js";
import "./forside.js";
import "./boat-comparison.js";
import "./header.js";
import "./dealer-searcher.js";
import "./popup.js";
import "./rfq-form.js";
import "./image-gallery.js";
import "./FAQ.js";
import "./boat.js";
import "./jquery.validate";
import "./omnicom.captcha";
import "./validation";
import "./lazy-preload";
//import "./config.es.js";